import { Box, Grid, Typography } from "@material-ui/core";
import { Android as AndroidIcon } from "@material-ui/icons";
import React from "react";
import { Order } from "../../../Shared/GeneratedTypes";
import { Localizations } from "../../../Shared/sharedTypes";

interface PropTypes {
    quickCode: string;
    order: Order;
    localizations: Localizations;
}
export default function Android({ quickCode, order, localizations }: PropTypes) {
    return (
        <Grid
            container
            justify="center"
            style={{
                // position: "absolute",
                width: "100%",
                minHeight: "100vh",
                padding: 20,
            }}
            alignItems="stretch"
        >
            <Grid
                container
                style={{ flex: 1 }}
                lg={4}
                sm={12}
                item
                direction="column"
                justify="flex-end"
                alignContent="stretch"
                alignItems="stretch"
            >
                <Grid
                    item
                    zeroMinWidth
                    style={{
                        flex: 1,
                    }}
                >
                    <Box textAlign="center">
                        <img
                            src={order.logoPhotoUrl}
                            alt="Carrier Logo"
                            style={{
                                marginTop: 24,
                                marginBottom: 12,
                                height: "120px",
                                filter: "drop-shadow(rgba(200, 200, 200, 0.5) 3px 2px 11px)",
                            }}
                        />
                    </Box>
                    <Box textAlign="center" fontSize="40">
                        <AndroidIcon />
                    </Box>
                    <Box
                        m={3}
                        p={3}
                        style={{
                            borderRadius: 20,
                            background: "rgba(0,0,0,.4)",
                            color: "#eee",
                        }}
                    >
                        <Typography variant="subtitle1" style={{ textAlign: "justify" }}>
                            {localizations.androidBrowserDetected}
                            <br />
                            <br />
                            {localizations.androidCopyToClipboard}
                        </Typography>
                    </Box>
                    <textarea value={window.location.origin + "/GuideStream/" + quickCode}></textarea>
                    <Box textAlign="center">
                        {localizations.PoweredBy} <br />
                        <img
                            src="/images/GuideStreamLogo.png"
                            alt="Powered by Guide Stream 360"
                            style={{
                                objectFit: "scale-down",
                                marginTop: 5,
                                marginBottom: 0,
                                maxWidth: "70%",
                                filter: "drop-shadow(rgba(0, 0, 0, 0.5) 3px 2px 11px)",
                            }}
                        />
                    </Box>
                </Grid>
            </Grid>
        </Grid>
    );
}
